/**
 * GadsExport.js — Self-Service-Export für EINE Kampagne (oben gewählt): Wochen × Berichte (b01–b12c) → ZIP.
 * Die Kampagnen-Auswahl ganz oben gilt für ALLES: Berichte, Fragen (inkl. b13/b14), Was-wurde-gemacht.
 * Backend: api/gads_export_bxx.php (ZIP) + gads_kpi_questions.php (Fragen) + gads_kpi_changelog.php (Log). Bearer.
 */
import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import './GadsKpi.css';

const API_BASE = '/api';
const KAMPS = [['VA', 'Verlustangst'], ['EF', 'Eifersucht'], ['EA', 'Emot. Abh.'], ['SO', 'Souveränität'], ['BR', 'Branding']];
// [key_intern (Daten-Tabelle) · anzeige (neue Nummerierung b0–b16) · label]
const REPORTS = [
  ['b0', 'b0', 'Änderungen'],
  ['b01', 'b1', 'Kampagne'], ['b02', 'b2', 'Auktionen'], ['b03', 'b3', 'Geräte'], ['b04', 'b4', 'Alter'], ['b05', 'b5', 'Standorte'],
  ['b06', 'b6', 'Werbezeitplan'], ['b07', 'b7', 'Zielgruppen'], ['b08', 'b8', 'Suchbegriffe'], ['b09', 'b9', 'Keywords'],
  ['b10', 'b10', 'Titel'], ['b11', 'b11', 'Texte'], ['b12', 'b12', 'Sitelinks'], ['b12a', 'b13', 'Marke'], ['b12c', 'b14', 'Bilder'],
  ['b13', 'b15', 'Zusammenfassung: K & LP'], ['b14', 'b16', 'User-Intent & eF-Profil'],
];
// Fragen-Liste = Daten-Berichte + Synthese-Fragen (b13/b14, keine Daten-Tabelle, nur Fragen)
const FRAGEN = REPORTS;
// Anzeige-Key (b0–b16, wie im Arbeitsbereich) → intern-Key (b0/b01…/b12a/b12c/b13/b14, wie in „2 Fragen")
const DISP2INTERN = Object.fromEntries(REPORTS.map(([intern, disp]) => [disp, intern]));
const SHORT2NAME = { VA: 'SEA_Verlustangst', EF: 'SEA_Eifersucht', EA: 'SEA_Emotionale_Abhaengigkeit', SO: 'SEA_Souveraenitaet', BR: 'SEA_Branding' };
const LP_FIELDS = [['url', 'URL'], ['fs1', 'FS1'], ['fs2', 'FS2'], ['fs3', 'FS3'], ['fs4', 'FS4'], ['titel', 'Titel'], ['meta', 'Meta'], ['woerter', 'Anzahl Wörter'], ['dichte', 'FS-Dichte'], ['index_status', 'Index'], ['stand', 'Stand']];

export default function GadsExport() {
  const [kCamp, setKCamp] = useState('VA'); // EINE Kampagne, gilt für die ganze Seite
  const [weeks, setWeeks] = useState(null);
  const [selWeeks, setSelWeeks] = useState({});
  const [selR, setSelR] = useState(Object.fromEntries(REPORTS.map(r => [r[0], true])));
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');
  const [err, setErr] = useState('');
  // Fragen
  const [frText, setFrText] = useState({});
  const [selFr, setSelFr] = useState(Object.fromEntries(FRAGEN.map(r => [r[0], true])));
  const [frBusy, setFrBusy] = useState(false);
  const [frMsg, setFrMsg] = useState('');
  const [bigTa, setBigTa] = useState({}); // bxx → vergrößert (Doppelklick)
  // Was wurde gemacht (K × Woche)
  const [clWeek, setClWeek] = useState('');
  const [clData, setClData] = useState({ lp_name: '', k_gads: [], k_manual: '', lp: '', source: 'auto' });
  const [clHbPrev, setClHbPrev] = useState({ K: [], LP: [] }); // Vorwochen-Umsetzung je Plan (K/LP) → „Was wurde gemacht"
  const [clBusy, setClBusy] = useState(false);
  const [clMsg, setClMsg] = useState('');
  const [inclCl, setInclCl] = useState(false); // Abschnitt 5 (K-Änderungen) entfernt → Änderungslog ist jetzt b0
  const [inclCdhvK, setInclCdhvK] = useState(true); // CD-HV-K.csv (Abschnitt 3)
  const [inclCdhvLP, setInclCdhvLP] = useState(true); // CD-HV-LP.csv (Abschnitt 4)
  const [inclJourney, setInclJourney] = useState(true); // Journey+Profil ins ZIP (LP-Wirkung)
  const [inclLpMeta, setInclLpMeta] = useState(true); // LP-Stammdaten ins ZIP
  // Journey/Profil-Vorschau (was geht an CD)
  const [jrPrev, setJrPrev] = useState(null); // {sekHead, sekBody, sekN, profHead, profBody, profN}
  const [jrBusy, setJrBusy] = useState(false);
  // LP-Stammdaten (Header der lpxx.md, editierbar)
  const [lpRows, setLpRows] = useState([]);
  const [lpBusy, setLpBusy] = useState(false);
  const [lpMsg, setLpMsg] = useState('');
  // Bereich 6 — CD-Empfehlungen (b13), Import per Datei-Dialog
  const [b13Rows, setB13Rows] = useState([]);
  const [b13Prev, setB13Prev] = useState({ week: '', rows: [] });
  const [b13Open, setB13Open] = useState(false);
  const [b13File, setB13File] = useState('');
  const [b13Raw, setB13Raw] = useState('');
  const [b13ImpPrev, setB13ImpPrev] = useState(null);
  const [b13Busy, setB13Busy] = useState(false);
  const [b13Msg, setB13Msg] = useState('');
  // Bereich 9 = Handlungsplan K · Bereich 10 = Handlungsplan LP (je Plan: content + abhakbare Anweisungen)
  const [hb, setHb] = useState({ K: { content: '', checked: [], struktur: [], edit: false, busy: false, msg: '' }, LP: { content: '', checked: [], struktur: [], edit: false, busy: false, msg: '' } });
  const patchHb = (typ, patch) => setHb(s => ({ ...s, [typ]: { ...s[typ], ...patch } }));
  const [clBig, setClBig] = useState({}); // 'km' | 'lp' → vergrößert
  // Änderungsverlauf-Import (CSV-Datei wählen → Vorschau → Speichern)
  const [impOpen, setImpOpen] = useState(false);
  const [impRaw, setImpRaw] = useState('');
  const [impFile, setImpFile] = useState('');
  const [impPrev, setImpPrev] = useState(null);
  const [impBusy, setImpBusy] = useState(false);
  const [impMsg, setImpMsg] = useState('');

  const token = () => localStorage.getItem('token') || '';

  useEffect(() => {
    fetch(`${API_BASE}/gads_export_bxx.php?list=weeks`, { headers: { Authorization: 'Bearer ' + token() } })
      .then(r => r.json())
      .then(j => { if (j.success) { setWeeks(j.weeks); setSelWeeks(Object.fromEntries(j.weeks.slice(0, 2).map(w => [w.from, true]))); setClWeek(j.weeks[0]?.from || ''); } else setErr(j.message || 'Fehler'); })
      .catch(e => setErr(String(e)));
  }, []);

  const loadChangelog = useCallback((camp, week) => {
    if (!week) return;
    setClMsg('');
    fetch(`${API_BASE}/gads_kpi_changelog.php?campaign=${camp}&week=${week}`, { headers: { Authorization: 'Bearer ' + token() } })
      .then(r => r.json())
      .then(j => { if (j.success) setClData({ lp_name: j.lp_name || '', k_gads: j.k_gads || [], k_manual: j.k_manual || '', lp: j.lp || '', source: j.source || 'auto' }); })
      .catch(() => {});
    // Vorwochen-Umsetzung je Plan (K/LP) — SAUBER aus ads_hb_umsetzung (zeile + erledigt_am), kein rohes checked
    const prev = new Date(new Date(week).getTime() - 7 * 864e5).toISOString().slice(0, 10);
    setClHbPrev({ K: [], LP: [] });
    ['K', 'LP'].forEach(typ => {
      fetch(`${API_BASE}/gads_hb.php?campaign=${camp}&week=${prev}&typ=${typ}&umsetzung=1`, { headers: { Authorization: 'Bearer ' + token() } })
        .then(r => r.json()).then(j => { setClHbPrev(s => ({ ...s, [typ]: j.success ? (j.umsetzung || []) : [] })); }).catch(() => {});
    });
  }, []);
  useEffect(() => { loadChangelog(kCamp, clWeek); }, [kCamp, clWeek, loadChangelog]);
  // „Was wurde gemacht"-Woche innerhalb des oben gewählten Zeitraums halten
  useEffect(() => {
    const sel = Object.keys(selWeeks).filter(k => selWeeks[k]);
    if (sel.length && !sel.includes(clWeek)) setClWeek(sel[0]);
    if (!sel.length && clWeek) setClWeek('');
  }, [selWeeks]); // eslint-disable-line react-hooks/exhaustive-deps

  const impPreview = async (raw) => {
    const csv = (raw != null ? raw : impRaw);
    if (!csv.trim()) return;
    setImpBusy(true); setImpMsg(''); setImpPrev(null);
    try {
      const res = await fetch(`${API_BASE}/gads_kpi_changelog.php`, {
        method: 'POST', headers: { Authorization: 'Bearer ' + token(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'preview', campaign: kCamp, csv }),
      });
      const j = await res.json();
      if (j.success) { setImpPrev(j); if (!j.groups.length) setImpMsg('Keine Änderungen erkannt — ist es der GADS-Änderungsverlauf-CSV-Export?'); }
      else setImpMsg('Fehler: ' + (j.message || ''));
    } catch (e) { setImpMsg('Fehler: ' + e); }
    setImpBusy(false);
  };

  const handleImpFile = (e) => {
    const f = e.target.files && e.target.files[0];
    e.target.value = ''; // erlaubt erneutes Wählen derselben Datei
    if (!f) return;
    setImpFile(f.name); setImpMsg(''); setImpPrev(null);
    const reader = new FileReader();
    reader.onload = () => { const text = String(reader.result || ''); setImpRaw(text); impPreview(text); };
    reader.onerror = () => setImpMsg('Datei konnte nicht gelesen werden.');
    reader.readAsText(f);
  };

  const impSave = async () => {
    if (!impPrev || !impPrev.groups.length) return;
    setImpBusy(true); setImpMsg('');
    try {
      const res = await fetch(`${API_BASE}/gads_kpi_changelog.php`, {
        method: 'POST', headers: { Authorization: 'Bearer ' + token(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ action: 'import', campaign: kCamp, csv: impRaw }),
      });
      const j = await res.json();
      if (j.success) {
        setImpMsg(`✔ ${j.imported} Einträge importiert: ${(j.weeks || []).join(' · ')}`);
        setImpRaw(''); setImpFile(''); setImpPrev(null); loadChangelog(kCamp, clWeek);
      } else setImpMsg('Fehler: ' + (j.message || ''));
    } catch (e) { setImpMsg('Fehler: ' + e); }
    setImpBusy(false);
  };

  const saveChangelog = async () => {
    setClBusy(true); setClMsg('');
    try {
      const res = await fetch(`${API_BASE}/gads_kpi_changelog.php`, {
        method: 'POST', headers: { Authorization: 'Bearer ' + token(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ campaign: kCamp, week: clWeek, k_manual: clData.k_manual, lp: clData.lp }),
      });
      const j = await res.json();
      setClMsg(j.success ? '✔ gespeichert' : ('Fehler: ' + (j.message || '')));
    } catch (e) { setClMsg('Fehler: ' + e); }
    setClBusy(false);
  };

  // LP-Stammdaten (Header der lpxx.md) laden/speichern
  const loadLpMeta = useCallback((camp) => {
    setLpMsg('');
    fetch(`${API_BASE}/gads_lp_meta.php?campaign=${camp}`, { headers: { Authorization: 'Bearer ' + token() } })
      .then(r => r.json()).then(j => { if (j.success) setLpRows(j.rows || []); }).catch(() => {});
  }, []);
  useEffect(() => { loadLpMeta(kCamp); }, [kCamp, loadLpMeta]);

  const setLpField = (i, f, v) => setLpRows(rs => rs.map((r, j) => j === i ? { ...r, [f]: v } : r));

  const saveLpMeta = async () => {
    setLpBusy(true); setLpMsg('');
    try {
      for (const row of lpRows) {
        await fetch(`${API_BASE}/gads_lp_meta.php`, { method: 'POST', headers: { Authorization: 'Bearer ' + token(), 'Content-Type': 'application/json' }, body: JSON.stringify(row) });
      }
      setLpMsg('✔ gespeichert');
    } catch (e) { setLpMsg('Fehler: ' + e); }
    setLpBusy(false);
  };

  // Bereich 6 — CD-Empfehlungen (b13) laden + importieren
  const loadB13 = useCallback((camp, week) => {
    if (!week) return;
    fetch(`${API_BASE}/gads_kpi_b13.php?campaign=${camp}&week=${week}`, { headers: { Authorization: 'Bearer ' + token() } })
      .then(r => r.json())
      .then(j => { if (j.success) { setB13Rows(j.rows || []); setB13Prev({ week: j.prev_week || '', rows: j.prev_rows || [] }); } })
      .catch(() => {});
  }, []);
  useEffect(() => { loadB13(kCamp, clWeek); }, [kCamp, clWeek, loadB13]);

  const b13Preview = async (raw) => {
    if (!raw.trim()) return;
    setB13Busy(true); setB13Msg(''); setB13ImpPrev(null);
    try {
      const res = await fetch(`${API_BASE}/gads_kpi_b13.php`, { method: 'POST', headers: { Authorization: 'Bearer ' + token(), 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'preview', campaign: kCamp, csv: raw }) });
      const j = await res.json();
      if (j.success) { setB13ImpPrev(j); if (!j.groups.length) setB13Msg('Keine Empfehlungen erkannt — Format: Kampagne;Woche;Bereich;Empfehlung;Priorität;Begründung'); }
      else setB13Msg('Fehler: ' + (j.message || ''));
    } catch (e) { setB13Msg('Fehler: ' + e); }
    setB13Busy(false);
  };
  const b13HandleFile = (e) => {
    const f = e.target.files && e.target.files[0]; e.target.value = '';
    if (!f) return;
    setB13File(f.name); setB13Msg(''); setB13ImpPrev(null);
    const reader = new FileReader();
    reader.onload = () => { const t = String(reader.result || ''); setB13Raw(t); b13Preview(t); };
    reader.readAsText(f);
  };
  const b13Save = async () => {
    if (!b13ImpPrev || !b13ImpPrev.groups.length) return;
    setB13Busy(true);
    try {
      const res = await fetch(`${API_BASE}/gads_kpi_b13.php`, { method: 'POST', headers: { Authorization: 'Bearer ' + token(), 'Content-Type': 'application/json' }, body: JSON.stringify({ action: 'import', campaign: kCamp, csv: b13Raw }) });
      const j = await res.json();
      if (j.success) { setB13Msg(`✔ ${j.imported} Empfehlungen importiert: ${(j.weeks || []).join(' · ')}`); setB13File(''); setB13Raw(''); setB13ImpPrev(null); loadB13(kCamp, clWeek); }
      else setB13Msg('Fehler: ' + (j.message || ''));
    } catch (e) { setB13Msg('Fehler: ' + e); }
    setB13Busy(false);
  };

  // Handlungspläne K + LP laden/speichern/abhaken
  const loadHb = useCallback((camp, week) => {
    if (!week) return;
    ['K', 'LP'].forEach(typ => {
      fetch(`${API_BASE}/gads_hb.php?campaign=${camp}&week=${week}&typ=${typ}`, { headers: { Authorization: 'Bearer ' + token() } })
        .then(r => r.json())
        .then(j => { if (j.success) setHb(s => ({ ...s, [typ]: { ...s[typ], content: j.content || '', checked: j.checked || [], edit: false, msg: '' } })); })
        .catch(() => {});
      fetch(`${API_BASE}/gads_hb.php?campaign=${camp}&week=${week}&typ=${typ}&struktur=1`, { headers: { Authorization: 'Bearer ' + token() } })
        .then(r => r.json())
        .then(j => { if (j.success) setHb(s => ({ ...s, [typ]: { ...s[typ], struktur: j.kategorien || [] } })); })
        .catch(() => {});
    });
  }, []);
  useEffect(() => { loadHb(kCamp, clWeek); }, [kCamp, clWeek, loadHb]);

  // Bereiche 8+9 — Arbeitsansicht je Kategorie (Daten + Entscheidung E/P/V).
  // K: b0–b16 (GADS-Roh-Daten je bx) · LP: a1–a11 (aktueller LP-Section-Inhalt aus ads_lp_sections).
  const [bxData, setBxData] = useState({ K: [], LP: [] });
  const [bxLoc, setBxLoc] = useState({});
  const [bxMsg, setBxMsg] = useState('');
  const [bxSort, setBxSort] = useState({}); // je Tabelle (`${typ}-${kat}`) → { col, dir:1|-1 }
  const bxIsNum = s => s != null && /^-?\d+(\.\d+)?$/.test(String(s).trim());
  const bxCmp = (col, dir) => (a, b) => {
    const x = a[col], y = b[col]; const ex = x == null || x === '', ey = y == null || y === '';
    if (ex && ey) return 0; if (ex) return 1; if (ey) return -1;
    if (bxIsNum(x) && bxIsNum(y)) return (parseFloat(x) - parseFloat(y)) * dir;
    return String(x).localeCompare(String(y), 'de', { numeric: true }) * dir;
  };
  // Die oben angehakten Wochen (period_from) — Datentabellen zeigen ALLE, absteigend (neueste zuerst)
  const selCsv = Object.keys(selWeeks).filter(k => selWeeks[k]).sort().reverse().join(',');
  const loadBx = useCallback((camp, week, typ, weeksCsv) => {
    if (!week) return;
    const wq = weeksCsv ? `&weeks=${encodeURIComponent(weeksCsv)}` : '';
    fetch(`${API_BASE}/gads_hb_bx.php?campaign=${camp}&week=${week}&typ=${typ}${wq}`, { headers: { Authorization: 'Bearer ' + token() } })
      .then(r => r.json()).then(j => { if (j.success) setBxData(s => ({ ...s, [typ]: j.kategorien || [] })); }).catch(() => {});
  }, []);
  useEffect(() => { loadBx(kCamp, clWeek, 'K', selCsv); loadBx(kCamp, clWeek, 'LP', selCsv); setBxLoc({}); }, [kCamp, clWeek, selCsv, loadBx]);
  const saveBxRow = async (typ, kat, nummer, zeile, prognose, erledigt, verdikt) => {
    setBxMsg('⏳ …');
    try {
      await fetch(`${API_BASE}/gads_hb_bx.php`, { method: 'POST', headers: { Authorization: 'Bearer ' + token(), 'Content-Type': 'application/json' }, body: JSON.stringify({ campaign: kCamp, week: clWeek, typ, kategorie: kat, nummer, zeile, prognose, erledigt, verdikt: verdikt ?? '' }) });
      setBxMsg('✓ gespeichert'); loadBx(kCamp, clWeek, typ, selCsv); setTimeout(() => setBxMsg(''), 1500);
    } catch { setBxMsg('Fehler'); }
  };
  // E/P/V-Icon-Badge: Doppelklick vergrößert das Feld, erneuter Doppelklick schließt + speichert.
  const bxBadge = (bigKey, color, letter, onSaveClose) => (
    <span onDoubleClick={() => { const wasBig = !!bigTa[bigKey]; setBigTa(s => ({ ...s, [bigKey]: !s[bigKey] })); if (wasBig) onSaveClose(); }}
      title="Doppelklick = großes Feld / erneut = schließen & speichern"
      style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 18, height: 18, borderRadius: 4, background: color, color: '#fff', fontSize: 11, fontWeight: 700, cursor: 'pointer', userSelect: 'none', flexShrink: 0 }}>{letter}</span>
  );
  // LP-Fragen (a1–a11) direkt hier speichern — persistiert in ads_kpi_questions (nur diesen a-Key)
  const saveBxQuestion = async (aKey) => {
    setBxMsg('⏳ …');
    try {
      await fetch(`${API_BASE}/gads_kpi_questions.php`, { method: 'POST', headers: { Authorization: 'Bearer ' + token(), 'Content-Type': 'application/json' }, body: JSON.stringify({ campaign: kCamp, questions: { [aKey]: frText[aKey] || '' } }) });
      setBxMsg('✓ Frage gespeichert'); setTimeout(() => setBxMsg(''), 1500);
    } catch { setBxMsg('Fehler'); }
  };
  const renderBxPlan = (nr, title, typ, hint) => {
    const list = bxData[typ] || [];
    // Akzentfarbe je Plan: K = Indigo · LP = Teal — grenzt die beiden Arbeitsbereiche und die Karten visuell ab
    const accent = typ === 'LP'
      ? { border: '#5eead4', badge: '#0d9488', head: 'linear-gradient(90deg,#ccfbf1,#f0fdfa)', ring: 'rgba(13,148,136,.15)' }
      : { border: '#a5b4fc', badge: '#4f46e5', head: 'linear-gradient(90deg,#e0e7ff,#eef2ff)', ring: 'rgba(79,70,229,.15)' };
    return (
    <section className="gk-section">
      <div className="gk-head" style={{ cursor: 'default' }}>
        <span>{nr} · {title} <small style={{ fontWeight: 400 }}>({kCamp} × gewählte Zeiträume — {hint})</small></span>
        {bxMsg && <span className="gx-frmsg">{bxMsg}</span>}
      </div>
      <div className="gx-frbody">
        {typ === 'LP' && (
          <div style={{ marginBottom: 10, background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, padding: 8 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 4 }}>
              <span style={{ fontWeight: 600, fontSize: 13 }}>📋 LP-Stammdaten <small style={{ fontWeight: 400 }}>(Basis · read-only — Header der <code>_LPxx.md</code>)</small></span>
              <label className="gx-clincl" style={{ margin: 0 }}><input type="checkbox" checked={inclLpMeta} onChange={() => setInclLpMeta(v => !v)} /> ins ZIP</label>
            </div>
            <div className="gx-frhint">Wahrheit = <code>_LPxx.md</code>-Header (git). <strong>Nur lesbar</strong> — ändern ausschließlich in der MD, dann spiegelt <code>bin/lp-stammdaten-sync</code> es auf den Server (MD → <code>ads_lp_meta</code>).</div>
            {lpRows.length === 0 ? <div className="gk-placeholder">keine LP-Stammdaten für {kCamp} — erst <code>bin/lp-stammdaten-sync</code> laufen lassen.</div> : lpRows.map((r) => (
              <div key={r.lp_id} className="gx-lprow">
                <div className="gx-lpid">{r.lp_id}</div>
                <div className="gx-lpfields">
                  {LP_FIELDS.map(([f, lbl]) => (
                    <div key={f} className="gx-lpfield"><span className="gx-lplbl">{lbl}</span>
                      <span style={{ fontSize: 12, color: '#0f172a', wordBreak: 'break-word' }}>{r[f] == null || r[f] === '' ? '—' : r[f]}</span>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
        {list.length === 0 ? <span className="gk-placeholder">(lädt …)</span> : list.map(k => {
          const nextNr = k.eintraege.reduce((m, e) => Math.max(m, e.nummer || 0), 0) + 1;
          const nk = `${typ}-${k.kat}-new`; const nl = bxLoc[nk] || {};
          const sk = `${typ}-${k.kat}`; const sort = bxSort[sk];
          const dispRows = sort ? [...(k.rows || [])].sort(bxCmp(sort.col, sort.dir)) : (k.rows || []);
          const grouped = !sort || sort.col === 0; // Wochen-Trennlinie nur sinnvoll bei Default/Sort nach period_from
          const qKey = typ === 'K' ? DISP2INTERN[k.kat] : k.kat; // Fragen-Key (K: intern-Key, LP: a-Key)
          const eKey = `${nk}-E`, pKey = `${nk}-P`, vKey = `${nk}-V`;
          const bigE = !!bigTa[eKey], bigP = !!bigTa[pKey], bigV = !!bigTa[vKey];
          const saveNew = () => {
            const z = (nl.zeile || '').trim(); if (!z) return;
            saveBxRow(typ, k.kat, nextNr, z, nl.prognose || '', false, nl.verdikt || '');
            setBxLoc(s => { const n = { ...s }; delete n[nk]; return n; });
            setBigTa(s => { const n = { ...s }; delete n[eKey]; delete n[pKey]; delete n[vKey]; return n; });
          };
          return (
            <div key={k.kat} style={{ border: `2px solid ${accent.border}`, borderRadius: 10, marginBottom: 16, padding: 10, background: '#fff', boxShadow: `0 1px 4px rgba(30,41,59,.10), 0 0 0 3px ${accent.ring}` }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, margin: '-10px -10px 10px', padding: '7px 10px', background: accent.head, borderBottom: `2px solid ${accent.border}`, borderRadius: '8px 8px 0 0' }}>
                <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', minWidth: 32, height: 22, padding: '0 9px', borderRadius: 11, background: accent.badge, color: '#fff', fontSize: 12, fontWeight: 700 }}>{k.kat}</span>
                <span style={{ fontWeight: 700, fontSize: 13, color: '#1e293b' }}>{k.label}</span>
              </div>
              <div style={{ marginBottom: 6, background: '#faf5ff', border: '1px solid #ede9fe', borderRadius: 4, padding: '4px 8px' }}>
                <div style={{ fontSize: 11, fontWeight: 600, color: '#6d28d9', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span>❓ Fragen — eine pro Zeile</span>
                  <button className="gk-kbtn" onClick={() => saveBxQuestion(qKey)}>💾</button>
                </div>
                <textarea
                  onDoubleClick={() => { const bk = `${typ}-${qKey}`; const wasBig = !!bigTa[bk]; setBigTa(s => ({ ...s, [bk]: !s[bk] })); if (wasBig) saveBxQuestion(qKey); }}
                  style={{ width: '100%', minHeight: bigTa[`${typ}-${qKey}`] ? 260 : 44, fontSize: 12, marginTop: 2, resize: 'vertical', boxSizing: 'border-box' }}
                  value={frText[qKey] || ''} onChange={e => setFrText(t => ({ ...t, [qKey]: e.target.value }))}
                  placeholder="(noch keine Fragen — hier eintragen; Doppelklick = großes Fenster, erneut = schließen & speichern)" />
              </div>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#475569', margin: '4px 0 3px', letterSpacing: '.02em' }}>📊 Daten — gewählte Zeiträume</div>
              <div style={{ maxHeight: 240, overflow: 'auto', border: '1px solid #cbd5e1', borderRadius: 4, marginBottom: 6 }}>
                {k.rows && k.rows.length ? (
                  <table style={{ borderCollapse: 'separate', borderSpacing: 0, fontSize: 11, width: '100%' }}>
                    <thead>
                      <tr>{(k.cols || []).map((c, ci) => {
                        const active = sort && sort.col === ci;
                        return <th key={c} onClick={() => setBxSort(s => ({ ...s, [sk]: { col: ci, dir: active ? -sort.dir : 1 } }))} title="klicken zum Sortieren" style={{ position: 'sticky', top: 0, zIndex: 2, background: active ? '#cbd5e1' : '#e2e8f0', color: '#0f172a', borderRight: '1px solid #cbd5e1', borderBottom: '2px solid #94a3b8', padding: '3px 6px', textAlign: 'left', whiteSpace: 'nowrap', fontWeight: 700, cursor: 'pointer', userSelect: 'none' }}>{c}{active ? (sort.dir === 1 ? ' ▲' : ' ▼') : ''}</th>;
                      })}</tr>
                    </thead>
                    <tbody>
                      {dispRows.map((r, i) => {
                        const newWeek = grouped && i > 0 && dispRows[i - 1] && dispRows[i - 1][0] !== r[0];
                        return (
                          <tr key={i}>
                            {r.map((v, j) => {
                              const long = v != null && String(v).length > 60;
                              return <td key={j} style={{ color: '#0f172a', borderRight: '1px solid #eef2f7', borderBottom: '1px solid #eef2f7', padding: '2px 6px', verticalAlign: 'top', whiteSpace: long ? 'normal' : 'nowrap', ...(long ? { minWidth: 220, maxWidth: 420 } : {}), ...(newWeek ? { borderTop: '2px solid #94a3b8' } : {}), ...(j === 0 ? { fontWeight: 600, background: '#f1f5f9' } : {}) }}>{v == null ? '' : String(v)}</td>;
                            })}
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                ) : <em style={{ opacity: 0.5, fontSize: 12, padding: '4px 8px', display: 'block' }}>{k.err ? `(Fehler: ${k.err})` : (typ === 'LP' ? '(keine LP-Section-Daten)' : '(keine Daten im Zeitraum)')}</em>}
              </div>
              <div style={{ fontSize: 11, fontWeight: 700, color: '#475569', margin: '8px 0 3px', letterSpacing: '.02em', borderTop: '1px solid #f1f5f9', paddingTop: 6 }}>🎯 Entscheidung — <span style={{ color: '#2563eb' }}>E</span> · <span style={{ color: '#0891b2' }}>P</span> · <span style={{ color: '#b45309' }}>V</span></div>
              {k.eintraege.map(e => {
                const key = `${typ}-${k.kat}-${e.nummer}`; const loc = bxLoc[key] || {};
                const erl = loc.erledigt !== undefined ? loc.erledigt : !!e.erledigt_am;
                const zl = loc.zeile !== undefined ? loc.zeile : (e.zeile || '');
                const pr = loc.prognose !== undefined ? loc.prognose : (e.prognose || '');
                const vd = loc.verdikt !== undefined ? loc.verdikt : (e.verdikt || '');
                const eBK = `${key}-E`, pBK = `${key}-P`, vBK = `${key}-V`;
                const save = () => saveBxRow(typ, k.kat, e.nummer, zl, pr, erl, vd);
                const row = (bk, badgeColor, textColor, letter, val, field, ph) => (
                  <div style={{ display: 'flex', gap: 6, alignItems: bigTa[bk] ? 'flex-start' : 'center', marginBottom: 3 }}>
                    {bxBadge(bk, badgeColor, letter, save)}
                    {bigTa[bk]
                      ? <textarea autoFocus style={{ flex: 1, minHeight: 90, fontSize: 12, color: textColor, resize: 'vertical', boxSizing: 'border-box' }} value={val} onChange={ev => setBxLoc(s => ({ ...s, [key]: { ...loc, [field]: ev.target.value } }))} />
                      : <input style={{ flex: 1, fontSize: 12, color: textColor }} value={val} onChange={ev => setBxLoc(s => ({ ...s, [key]: { ...loc, [field]: ev.target.value } }))} placeholder={ph} />}
                  </div>
                );
                return (
                  <div key={e.id} style={{ border: '1px solid #e2e8f0', borderRadius: 6, padding: '6px 8px', marginBottom: 6, background: '#fafbfc' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 5, fontSize: 11 }}>
                      <input type="checkbox" checked={erl} onChange={ev => { const nv = ev.target.checked; setBxLoc(s => ({ ...s, [key]: { ...loc, erledigt: nv } })); saveBxRow(typ, k.kat, e.nummer, zl, pr, nv, vd); }} title="erledigt markieren (Datum/Uhrzeit intern)" />
                      <span style={{ color: erl ? '#16a34a' : '#94a3b8', fontWeight: 600 }}>{erl ? `✓ erledigt${e.erledigt_am ? ' · ' + e.erledigt_am.slice(0, 16) : ''}` : 'offen'}</span>
                      <span style={{ marginLeft: 'auto', color: '#cbd5e1', fontSize: 10 }}>#{e.nummer}</span>
                    </div>
                    {row(eBK, '#2563eb', undefined, 'E', zl, 'zeile', 'Handlungsempfehlung')}
                    {row(pBK, '#0891b2', '#0891b2', 'P', pr, 'prognose', 'Prognose — Metrik + Schwelle (prüfbar in 7 T)')}
                    {row(vBK, '#b45309', '#b45309', 'V', vd, 'verdikt', 'Verdikt (wird i.d.R. nächste Woche gesetzt)')}
                  </div>
                );
              })}
              <div style={{ border: '1px dashed #94a3b8', borderRadius: 6, padding: '6px 8px', marginTop: 8, background: '#f8fafc' }}>
                <div style={{ fontSize: 11, fontWeight: 700, color: '#64748b', marginBottom: 5 }}>➕ neue Empfehlung <small style={{ fontWeight: 400 }}>(Doppelklick auf E/P/V = großes Feld · erneut = speichern)</small></div>
                {[['E', eKey, bigE, '#2563eb', undefined, 'zeile', nl.zeile, 'Handlungsempfehlung'],
                  ['P', pKey, bigP, '#0891b2', '#0891b2', 'prognose', nl.prognose, 'Prognose'],
                  ['V', vKey, bigV, '#b45309', '#b45309', 'verdikt', nl.verdikt, 'Verdikt (wird i.d.R. nächste Woche gesetzt)']
                ].map(([letter, bk, big, badgeColor, textColor, field, val, ph]) => (
                  <div key={letter} style={{ display: 'flex', gap: 6, alignItems: big ? 'flex-start' : 'center', marginBottom: 3 }}>
                    {bxBadge(bk, badgeColor, letter, saveNew)}
                    {big
                      ? <textarea autoFocus style={{ flex: 1, minHeight: 100, fontSize: 12, color: textColor, resize: 'vertical', boxSizing: 'border-box' }} value={val || ''} onChange={ev => setBxLoc(s => ({ ...s, [nk]: { ...nl, [field]: ev.target.value } }))} placeholder={ph} />
                      : <input style={{ flex: 1, fontSize: 12, color: textColor }} value={val || ''} onChange={ev => setBxLoc(s => ({ ...s, [nk]: { ...nl, [field]: ev.target.value } }))} placeholder={ph} />}
                  </div>
                ))}
              </div>
            </div>
          );
        })}
      </div>
    </section>
    );
  };

  const saveHb = async (typ, content, checked, quiet) => {
    patchHb(typ, quiet ? { busy: true } : { busy: true, msg: '' });
    try {
      const res = await fetch(`${API_BASE}/gads_hb.php`, { method: 'POST', headers: { Authorization: 'Bearer ' + token(), 'Content-Type': 'application/json' }, body: JSON.stringify({ campaign: kCamp, week: clWeek, typ, content, checked }) });
      const j = await res.json();
      patchHb(typ, quiet ? { busy: false } : { busy: false, msg: j.success ? '✔ gespeichert' : ('Fehler: ' + (j.message || '')) });
    } catch (e) { patchHb(typ, quiet ? { busy: false } : { busy: false, msg: 'Fehler: ' + e }); }
  };
  const hbToggle = (typ, line) => {
    const cur = hb[typ];
    const next = cur.checked.includes(line) ? cur.checked.filter(l => l !== line) : [...cur.checked, line];
    patchHb(typ, { checked: next }); saveHb(typ, cur.content, next, true);
  };
  const renderHbPlan = (typ, nr, title, hint) => {
    const st = hb[typ];
    const zeilenAll = (st.struktur || []).flatMap(k => k.zeilen);
    const nTotal = zeilenAll.length;
    const nDone = zeilenAll.filter(z => z.erledigt_am).length;
    return (
      <section className="gk-section">
        <div className="gk-head" style={{ cursor: 'default' }}>
          <span>{nr} · {title} <small style={{ fontWeight: 400 }}>({kCamp} × gewählte Zeiträume — {hint})</small></span>
          <span className="gx-frtop">
            <span className="gk-toolbar-hint">{nDone}/{nTotal} erledigt</span>
            <button className="gk-kbtn" onClick={() => { if (st.edit) saveHb(typ, st.content, st.checked); patchHb(typ, { edit: !st.edit }); }} disabled={st.busy}>{st.edit ? '💾 Speichern & schließen' : '✎ Freitext bearbeiten'}</button>
            {st.msg && <span className="gx-frmsg">{st.msg}</span>}
          </span>
        </div>
        <div className="gx-frbody">
          {st.edit ? (
            <textarea className="gx-frta gx-hb-edit" rows={20} value={st.content} onChange={e => patchHb(typ, { content: e.target.value })}
              placeholder="(eine Zeile je Anweisung; Zeilen mit # = Überschriften)" />
          ) : (st.struktur || []).length === 0 ? (
            <span className="gk-placeholder">(lädt …)</span>
          ) : (
            <div className="gx-hb-list">
              {st.struktur.map(k => {
                const done = k.zeilen.filter(z => z.erledigt_am).length;
                return (
                  <div key={k.kat} style={{ marginBottom: 4, opacity: k.zeilen.length ? 1 : 0.4 }}>
                    <div style={{ fontSize: 12.5, fontWeight: 600, borderBottom: '1px solid var(--gk-border,#e5e7eb)', padding: '4px 0 2px' }}>
                      <span style={{ display: 'inline-block', minWidth: 38, color: '#2563eb' }}>{k.kat}</span>{k.label}
                      {k.zeilen.length > 0 && <small style={{ fontWeight: 400, color: '#888' }}> · {done}/{k.zeilen.length}</small>}
                    </div>
                    {k.zeilen.map(z => (
                      <div key={z.id} style={{ padding: '3px 0 3px 38px', fontSize: 13 }}>
                        <div className={z.erledigt_am ? 'gx-hb-done' : ''}>
                          <span style={{ color: z.erledigt_am ? '#16a34a' : '#bbb' }}>{z.erledigt_am ? '✅' : '○'}</span> {z.nummer}. {(z.zeile || '').replace(/^\d+\.\s*/, '')}
                          {z.warum_bx && <em style={{ color: '#888', fontStyle: 'normal' }}> (← {z.warum_bx})</em>}
                        </div>
                        {z.prognose && <div style={{ color: '#0891b2', fontSize: 12, paddingLeft: 20 }}>P: {z.prognose}</div>}
                        {z.verdikt && <div style={{ color: '#b45309', fontSize: 12, paddingLeft: 20 }}>V: {z.verdikt}</div>}
                      </div>
                    ))}
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </section>
    );
  };

  // Journey/Profil-Vorschau (was geht an CD) — für den gewählten Zeitraum
  const jrPreview = async () => {
    const wks = picks(selWeeks); if (!wks.length) { setJrPrev(null); return; }
    const sorted = [...wks].sort();
    const startDate = sorted[0];
    const endDate = new Date(new Date(sorted[sorted.length - 1]).getTime() + 6 * 864e5).toISOString().slice(0, 10);
    const base = `startDate=${startDate}&endDate=${endDate}&campaign=${encodeURIComponent(SHORT2NAME[kCamp])}`;
    setJrBusy(true);
    try {
      const [sek, prof] = await Promise.all([
        fetch(`${API_BASE}/uje_export_csv.php?grain=sections&${base}`, { headers: { Authorization: 'Bearer ' + token() } }).then(r => r.text()),
        fetch(`${API_BASE}/uje_export_csv.php?grain=profil&${base}`, { headers: { Authorization: 'Bearer ' + token() } }).then(r => r.text()),
      ]);
      const sl = sek.trim().split('\n'), pl = prof.trim().split('\n');
      setJrPrev({ sekHead: sl[0] || '', sekBody: sl.slice(1, 9), sekN: Math.max(0, sl.length - 1), profHead: pl[0] || '', profBody: pl.slice(1, 9), profN: Math.max(0, pl.length - 1) });
    } catch (e) { setJrPrev(null); }
    setJrBusy(false);
  };

  const loadQuestions = useCallback((camp) => {
    setFrMsg('');
    fetch(`${API_BASE}/gads_kpi_questions.php?campaign=${camp}`, { headers: { Authorization: 'Bearer ' + token() } })
      .then(r => r.json())
      .then(j => { if (j.success) setFrText(Object.fromEntries(Object.entries(j.questions).map(([k, arr]) => [k, arr.join('\n')]))); })
      .catch(() => {});
  }, []);
  useEffect(() => { loadQuestions(kCamp); }, [kCamp, loadQuestions]);

  const saveQuestions = async () => {
    setFrBusy(true); setFrMsg('');
    try {
      const res = await fetch(`${API_BASE}/gads_kpi_questions.php`, {
        method: 'POST', headers: { Authorization: 'Bearer ' + token(), 'Content-Type': 'application/json' },
        body: JSON.stringify({ campaign: kCamp, questions: frText }),
      });
      const j = await res.json();
      setFrMsg(j.success ? `✔ ${kCamp}: ${j.saved} Fragen gespeichert` : ('Fehler: ' + (j.message || '')));
    } catch (e) { setFrMsg('Fehler: ' + e); }
    setFrBusy(false);
  };

  const toggle = (setter) => (key) => setter(s => ({ ...s, [key]: !s[key] }));
  const setAllR = v => setSelR(Object.fromEntries(REPORTS.map(r => [r[0], v])));
  const picks = obj => Object.keys(obj).filter(k => obj[k]);

  const doExport = async () => {
    const wks = picks(selWeeks), reps = picks(selR), frs = picks(selFr);
    if (!reps.length && !frs.length && !inclCdhvK && !inclCdhvLP && !inclCl && !inclJourney && !inclLpMeta) { setErr('Nichts gewählt — Berichte, Fragen, HV-K/HV-LP, K-Änderungen, Journey oder LP-Stammdaten.'); return; }
    if ((reps.length || inclCdhvK || inclCdhvLP || inclCl || inclJourney) && !wks.length) { setErr('Für Berichte / HV-K/HV-LP / K-Änderungen / Journey mindestens 1 Woche im Zeitraum wählen.'); return; }
    setErr(''); setMsg(''); setBusy(true);
    try {
      const p = new URLSearchParams({ campaigns: kCamp, weeks: wks.join(','), reports: reps.join(','), fragen: frs.join(','), cdhvk: inclCdhvK ? '1' : '', cdhvlp: inclCdhvLP ? '1' : '', changelog: inclCl ? '1' : '', journey: inclJourney ? '1' : '', lpmeta: inclLpMeta ? '1' : '' });
      const res = await fetch(`${API_BASE}/gads_export_bxx.php?${p}`, { headers: { Authorization: 'Bearer ' + token() } });
      if (!res.ok) { const t = await res.text(); throw new Error('HTTP ' + res.status + ' ' + t.slice(0, 120)); }
      const blob = await res.blob();
      const cd = res.headers.get('Content-Disposition') || '';
      const fname = (cd.match(/filename="([^"]+)"/) || [])[1] || 'GAds_Export.zip';
      const nf = res.headers.get('X-Files'), nr = res.headers.get('X-Rows');
      const a = document.createElement('a');
      a.href = URL.createObjectURL(blob); a.download = fname;
      document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(a.href);
      setMsg(`✔ ${fname} — ${nf || '?'} Dateien · ${nr || '?'} Zeilen`);
    } catch (e) { setErr(String(e.message || e)); }
    setBusy(false);
  };

  const chk = (on) => 'gk-kchk' + (on ? ' on' : '');
  const kFull = (KAMPS.find(k => k[0] === kCamp) || [kCamp, ''])[1];

  return (
    <div className="gk-wrap">
      <Link to="/admin" className="gk-back">← Zurück zum Dashboard</Link>
      <h2 className="gk-title">⬇ GADS Export <small>eine Kampagne · Wochen · Berichte · Fragen → ZIP (CSV)</small></h2>

      {/* Kampagne + Zeitraum ganz oben — gelten für ALLE CSVs */}
      <div className="gx-kbar">
        <span className="gx-kbar-lbl">Kampagne</span>
        <select className="gx-select gx-kbar-sel" value={kCamp} onChange={e => setKCamp(e.target.value)}>
          {KAMPS.map(([c, full]) => <option key={c} value={c}>{c} · {full}</option>)}
        </select>
        <span className="gx-kbar-lbl" style={{ marginLeft: 14 }}>Zeitraum</span>
        <div className="gx-kbar-weeks">
          {!weeks ? <span className="gk-placeholder">lädt…</span> : weeks.map(w => (
            <label key={w.from} className={chk(selWeeks[w.from])}><input type="checkbox" checked={!!selWeeks[w.from]} onChange={() => toggle(setSelWeeks)(w.from)} /><span>{w.label}</span></label>
          ))}
        </div>
      </div>
      <div className="gk-toolbar-hint" style={{ margin: '-8px 0 14px' }}>Kampagne + Zeitraum gelten für <strong>alle</strong> CSVs. Es werden immer die Wochen verglichen, die ausgewählt sind.</div>

      <section className="gk-section">
        <div className="gk-head" style={{ cursor: 'default' }}><span>1 · Berichte</span>
          <span><button className="gk-kbtn" onClick={() => setAllR(true)}>Alle an</button> <button className="gk-kbtn" onClick={() => setAllR(false)}>Alle ab</button></span>
        </div>
        <div className="gx-body">
          {REPORTS.map(([k, disp, lbl]) => (
            <label key={k} className={chk(selR[k])}><input type="checkbox" checked={!!selR[k]} onChange={() => toggle(setSelR)(k)} /><span>{disp} <small>{lbl}</small></span></label>
          ))}
        </div>
      </section>

      {/* 2 · Fragen — Anzeige entfernt (2026-07): Fragen sind jetzt im Arbeitsbereich K/LP je bx/a zugeordnet & editierbar.
          State (frText/selFr/loadQuestions) bleibt: speist die Panels im Arbeitsbereich + Fragen-CSV im ZIP. */}

      <section className="gk-section">
        <div className="gk-head" style={{ cursor: 'default' }}>
          <span>3 · Handlungsempfehlungen Vorwoche K <small style={{ fontWeight: 400 }}>(HV-K — CDs K-Empfehlungen der Vorwoche, 1:1 wie im HP-K, mit Umsetzungs-Datum)</small></span>
        </div>
        <div className="gx-frbody">
          <div className="gx-frhint">
            <label className="gx-clincl"><input type="checkbox" checked={inclCdhvK} onChange={() => setInclCdhvK(v => !v)} /> <strong>HV-K als <code>{kCamp}_CD-HV-K.csv</code> ins ZIP</strong> (für die gewählten Wochen)</label>
            <div>Die in der Vorwoche <strong>erledigten</strong> K-Empfehlungen, Text 1:1 wie im Handlungsplan K, mit <strong>Datum + Uhrzeit</strong> der Umsetzung.</div>
          </div>
          {clHbPrev.K.length > 0 ? (
            <div className="gx-clrow">
              <label className="gx-cllbl">Vorschau <small>({clHbPrev.K.length} erledigte K-Empfehlungen)</small></label>
              <div className="gx-imp-items">{clHbPrev.K.map((u, i) => <div key={'k' + i}>✅ <span style={{ opacity: 0.65 }}>{(u.erledigt_am || '').slice(0, 16)}</span> · {(u.zeile || '').replace(/^\d+\.\s*/, '')}</div>)}</div>
            </div>
          ) : <div className="gx-frhint" style={{ opacity: 0.7 }}>(keine erledigten K-Empfehlungen für die Vorwoche der gewählten Woche)</div>}
        </div>
      </section>

      <section className="gk-section">
        <div className="gk-head" style={{ cursor: 'default' }}>
          <span>4 · Handlungsempfehlungen Vorwoche LP <small style={{ fontWeight: 400 }}>(HV-LP — CDs LP-Empfehlungen der Vorwoche, 1:1 wie im HP-LP, mit Umsetzungs-Datum)</small></span>
        </div>
        <div className="gx-frbody">
          <div className="gx-frhint">
            <label className="gx-clincl"><input type="checkbox" checked={inclCdhvLP} onChange={() => setInclCdhvLP(v => !v)} /> <strong>HV-LP als <code>{kCamp}_CD-HV-LP.csv</code> ins ZIP</strong> (für die gewählten Wochen)</label>
            <div>Die in der Vorwoche <strong>erledigten</strong> LP-Empfehlungen, Text 1:1 wie im Handlungsplan LP, mit <strong>Datum + Uhrzeit</strong> der Umsetzung.</div>
          </div>
          {clHbPrev.LP.length > 0 ? (
            <div className="gx-clrow">
              <label className="gx-cllbl">Vorschau <small>({clHbPrev.LP.length} erledigte LP-Empfehlungen)</small></label>
              <div className="gx-imp-items">{clHbPrev.LP.map((u, i) => <div key={'l' + i}>✅ <span style={{ opacity: 0.65 }}>{(u.erledigt_am || '').slice(0, 16)}</span> · {(u.zeile || '').replace(/^\d+\.\s*/, '')}</div>)}</div>
            </div>
          ) : <div className="gx-frhint" style={{ opacity: 0.7 }}>(keine erledigten LP-Empfehlungen für die Vorwoche der gewählten Woche)</div>}
        </div>
      </section>

      <section className="gk-section">
        <div className="gk-head" style={{ cursor: 'default' }}>
          <span>5 · Journey + Profil <small style={{ fontWeight: 400 }}>(LP-Wirkung: wie die eF nach der Änderung über die LP lief)</small></span>
          <span className="gx-frtop">
            <label className="gx-clincl" style={{ margin: 0 }}><input type="checkbox" checked={inclJourney} onChange={() => setInclJourney(v => !v)} /> ins ZIP</label>
            <button className="gk-kbtn" onClick={jrPreview} disabled={jrBusy}>{jrBusy ? '⏳' : '🔍 Vorschau (was geht an CD)'}</button>
          </span>
        </div>
        <div className="gx-frbody">
          <div className="gx-frhint">Zwei CSVs für den Zeitraum: <code>{kCamp}_Journey_Sektionen.csv</code> (Sektions-Funnel je LP: Retention · Drop-off · CTA) + <code>{kCamp}_Journey_Profil.csv</code> (1 Zeile je Person: Durchlauf + Kontakt-Profil, inkl. <strong>Conversions ohne Journey</strong> = Cookie-Ablehner). Anonymisiert — kein Name/E-Mail.</div>
          {jrPrev && (
            <div className="gx-imp-prev">
              <div className="gx-cllbl">Sektionen-Funnel — {jrPrev.sekN} Zeilen</div>
              <div className="gx-imp-items">{[jrPrev.sekHead, ...jrPrev.sekBody].join('\n')}{jrPrev.sekN > 8 ? '\n…' : ''}</div>
              <div className="gx-cllbl" style={{ marginTop: 10 }}>Profil — {jrPrev.profN} Zeilen</div>
              <div className="gx-imp-items">{[jrPrev.profHead, ...jrPrev.profBody].join('\n')}{jrPrev.profN > 8 ? '\n…' : ''}</div>
            </div>
          )}
        </div>
      </section>

      {/* 6 · LP-Stammdaten — verschoben in den Arbeitsbereich LP (Bereich 9, oben als Basis).
          Der ZIP-Zusatz {kCamp}_LP_Sektionen.csv (a1–a11 Überschrift+Text aus LP-HTML) bleibt unberührt am Export gekoppelt. */}

      <section className="gk-section">
        <div className="gk-head" style={{ cursor: 'default' }}>
          <span>7 · CD-Empfehlungen (b13) <small style={{ fontWeight: 400 }}>({kCamp} × Woche — CDs Output; schließt den Loop)</small></span>
          <span className="gx-frtop">
            <button className="gk-kbtn gx-impbtn" onClick={() => { setB13Open(o => !o); setB13ImpPrev(null); setB13Msg(''); }}>{b13Open ? '✕ Import schließen' : '⬆ CD-Empfehlungen importieren'}</button>
          </span>
        </div>
        <div className="gx-frbody">
          <div className="gx-frhint">CDs Empfehlungs-CSV (<code>Kampagne;Woche;Bereich;Empfehlung;Priorität;Begründung</code>) → <code>ads_kpi_b13</code>. Die Empfehlungen der gewählten Wochen <strong>+ Vorwoche</strong> gehen automatisch mit ins ZIP (<code>{kCamp}_b13_Empfehlungen.csv</code>) → CD prüft nächste Woche „umgesetzt? Wirkung?".</div>
          {b13Open && (
            <div className="gx-imp">
              <div className="gx-imp-actions">
                <label className="gk-kbtn gx-filebtn">📄 CSV-Datei wählen…<input type="file" accept=".csv,text/csv,text/plain" onChange={b13HandleFile} /></label>
                {b13File && <span className="gx-frlbl">{b13File}</span>}
                {b13Busy && !b13ImpPrev && <span className="gx-frmsg">⏳ prüfe…</span>}
                {b13ImpPrev && b13ImpPrev.groups.length > 0 && <button className="gk-kbtn gx-go" onClick={b13Save} disabled={b13Busy}>{b13Busy ? '⏳ …' : `💾 Importieren (${b13ImpPrev.parsed})`}</button>}
                {b13Msg && <span className="gx-frmsg">{b13Msg}</span>}
              </div>
              {b13ImpPrev && b13ImpPrev.groups.length > 0 && (
                <div className="gx-imp-prev">{b13ImpPrev.groups.map((g, i) => (
                  <div key={i} className="gx-imp-grp"><strong>{g.campaign} · {g.week_label} ({g.count})</strong>
                    <div className="gx-imp-items">{g.items.slice(0, 5).map((it, j) => <div key={j}>[{it.prioritaet}] {it.bereich}: {it.empfehlung}</div>)}{g.count > 5 && <div>… +{g.count - 5}</div>}</div>
                  </div>))}</div>
              )}
            </div>
          )}
          <div className="gx-clrow">
            <label className="gx-cllbl">Gespeichert · diese Woche <small>({b13Rows.length})</small></label>
            <div className="gx-imp-items">{b13Rows.length ? b13Rows.map((r, i) => <div key={i}>[{r.prioritaet}] <strong>{r.bereich}</strong>: {r.empfehlung} <em>— {r.begruendung}</em></div>) : <span className="gk-placeholder">(noch keine — CDs Empfehlungen importieren)</span>}</div>
          </div>
          {b13Prev.rows.length > 0 && (
            <div className="gx-clrow">
              <label className="gx-cllbl">Vorwoche <small>({b13Prev.week} · {b13Prev.rows.length})</small></label>
              <div className="gx-imp-items">{b13Prev.rows.map((r, i) => <div key={i}>[{r.prioritaet}] <strong>{r.bereich}</strong>: {r.empfehlung}</div>)}</div>
            </div>
          )}
        </div>
      </section>

      {renderBxPlan(8, 'Arbeitsbereich K', 'K', 'Roh-Daten je bx + Entscheidung (E/P/V)')}
      {renderBxPlan(9, 'Arbeitsbereich LP', 'LP', 'LP-Section-Inhalt je a1–a11 + Entscheidung (E/P/V)')}

      <div className="gx-actions">
        <button className="gk-kbtn gx-go" onClick={doExport} disabled={busy}>{busy ? '⏳ erstelle ZIP…' : `⬇ ZIP erstellen (${kCamp})`}</button>
        <span className="gk-toolbar-hint">{kCamp} · {picks(selWeeks).length} Wochen · {picks(selR).length} Berichte · {picks(selFr).length} Fragen{inclCdhvK ? ' · +HV-K' : ''}{inclCdhvLP ? ' · +HV-LP' : ''}{inclJourney ? ' · +Journey' : ''}{inclLpMeta ? ' · +LP-Stammdaten' : ''}</span>
      </div>
      {err && <div className="gk-err">Fehler: {err}</div>}
      {msg && <div className="gx-ok">{msg}</div>}
      <p className="gk-toolbar-hint" style={{ marginTop: 12 }}>Ein ZIP je Kampagne (oben gewählt) für den gewählten Zeitraum: Berichte + Fragen + Was-wurde-gemacht + Journey/Profil + LP-Stammdaten (Semikolon, dt. Komma, UTF-8).</p>
    </div>
  );
}
